import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class CameraClustersService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	create(cameraGroup, callback) {
		const url = "/ecosystem/api/cameraClusters";
		const body = JSON.stringify(cameraGroup);
		this._restClient.exec_post(url, body, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/cameraClusters";
		this._restClient.exec_get(url, callback);
	}

	update(clusterId, update, callback) {
		const url = `/ecosystem/api/cameraClusters/${clusterId}`;
		const body = JSON.stringify(update);
		this._restClient.exec_put(url, body, callback);
	}

	delete(clusterId, callback) {
		const url = `/ecosystem/api/cameraClusters/${clusterId}`;
		this._restClient.exec_delete(url, callback);
	}
	getClustersByFilter(filters, callback) {
		const url = "/ecosystem/api/cameraClusters/getClustersByFilter";
		const body = JSON.stringify(filters);
		this._restClient.exec_post(url, body, callback);
	}
	subscribeCameraClusters(callback) {
		this._rc.subscribe("ecosystem", "/cameraClusters", {}, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}

	getById(clusterId, callback) {
		const url = `/ecosystem/api/cameraClusters/${clusterId}`;
		this._restClient.exec_get(url, callback);
	}
}
